<template>
    <div>
        <HeaderMenu></HeaderMenu>
        <div class="main_content course-details-page" v-if="listing != null">
            <section class="bread_crumb simulation_course">
                <div class="container">
                    <ul>
                        <li><router-link v-bind:to="'/'">Home</router-link></li>
                        <li>{{ listing.name_eng }}</li>
                    </ul>
                </div>
            </section>
            <div class="simulation_training_sec">
                <div class="container">
                    <div class="row align-items-center">
                        <div class="col-md-4">
                            <NwImg :src="hostname+'/admin/images/course_images/'+listing.image" />
                        </div>
                        <div class="col-md-8">
                            <div class="simulation_right_content">
                                <h3>{{ listing.name_eng }}</h3>
                                <ul>
                                    <li><span><i class="fas fa-calendar"></i></span> {{  format_date(listing.start_date,listing.end_date) }}</li>
                                    <li><span><i class="fas fa-map-marker-alt"></i></span> {{ listing.venue_eng }}</li>
                                    <li><span><i class="fas fa-clock"></i></span> {{ listing.days }} days</li>
                                    <li><span>CME hrs.</span>{{ listing.hours }} CME hrs</li>
                                    <li><span>Fees</span>SAR {{ listing.amount }} </li>
                                </ul>
                                <!-- <div class="cart-box" v-if="listing.qty > 0">
                                    <input type="number" v-model="qty" name="qty" @keypress="validateNumber">
                                    <a href="javascript:;" v-on:click="add_to_cart">Add To Cart</a>
                                </div>
                                <p class="cart_message" v-if="cart_message!=''">{{cart_message}}</p> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal fade course_detail_modal" id="myModal">
                <div class="modal-dialog">
                    <div class="modal-content">
                      <button type="button" class="close" data-dismiss="modal">&times;</button>
                        <div class="modal-body">
                            <div class="course_register_wrap">
                                <h3>Course Registration</h3>
                                <div class="training-course-wrap">
                                    <NwImg :src="this.$hostname+'/vue/course-registration.png'" />
                                    <div class="modal_course_wrapper">
                                        <h4>{{ listing.name_eng }}</h4>
                                        <!-- <form v-on:submit.prevent="course_register"> -->
                                        <form>
                                            <div class="row">
                                            <div class="disabled-layer"></div>
                                                <div class="col-md-6">
                                                    <label>Name:</label>
                                                    <input type="text" v-model="name" name="name" class="form-control">
                                                    <span class="error" v-if="errors.name">{{ getError(errors.name) }}</span>
                                                </div>
                                                <div class="col-md-6">
                                                    <label>SCFHS Registration No.:</label>
                                                    <input type="text" v-model="scfhs_number" name="scfhs_number" class="form-control">
                                                    <span class="error" v-if="errors.scfhs_number">{{ getError(errors.scfhs_number) }}</span>
                                                </div>
                                                <div class="col-md-6">
                                                    <label>Specialty / Position:</label>
                                                    <input type="text" v-model="profession" name="profession" class="form-control">
                                                    <span class="error" v-if="errors.profession">{{ getError(errors.profession) }}</span>
                                                </div>
                                                <div class="col-md-6">
                                                    <label>Place of work:</label>
                                                    <input type="text" v-model="workplace" name="workplace" class="form-control">
                                                    <span class="error" v-if="errors.workplace">{{ getError(errors.workplace) }}</span>
                                                </div>
                                                <div class="col-md-6">
                                                    <label>Mobile Number:</label>
                                                    <input type="tel" v-model="contact_number" name="contact_number" class="form-control">
                                                    <span class="error" v-if="errors.contact_number">{{ getError(errors.contact_number) }}</span>
                                                </div>
                                                <div class="col-md-6">
                                                    <label>E-mail:</label>
                                                    <input type="email" v-model="email" name="email" class="form-control">
                                                    <span class="error" v-if="errors.email">{{ getError(errors.email) }}</span>
                                                </div>
                                            </div>

                                            <!-- <div class="register_wrap">
                                                <input v-if="register_btn_loader==false" type="submit" class="register_btn" name="submit" value="Register now">
                                                <input v-if="register_btn_loader==true" type="button" class="register_btn" name="submit" value="Wait...">
                                            </div> -->
                                            <div class="register_wrap">
                                                <span v-on:click="add_to_cart" class="register_btn">Register now</span>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <div class="simulation_custom_content">
                <div class="simulation_content_head">
                    <h3>About the course</h3>
                </div>
                <div class="container">
                    <div  v-html="listing.about_course_eng" class="limit_text"></div>
                    <!--<div class="common_btn read-more-content">
                        <a href="javascript:;" class="read_btn">Read More</a>
                    </div>-->
                </div>
            </div>
            <!-- Prerequisites -->
            <div class="simulation_custom_content">
                <div class="simulation_content_head">
                    <h3>Prerequisites</h3>
                </div>
                <div class="container">
                    <div  v-html="listing.prerequisites_eng" class="limit_text"></div>
                    <!--<div class="common_btn read-more-content">
                        <a href="javascript:;" class="read_btn">Read More</a>
                    </div>-->
                </div>
            </div>

            <!-- Speakers -->
            <div class="simulation_custom_content">
                <div class="simulation_content_head">
                    <h3>Speakers</h3>
                </div>
                <div class="container">
                    <div  v-html="listing.speakers" class="limit_text"></div>
                    <!-- <p>Not Applicable</p> -->
                </div>
            </div>

            <!-- Curriculum -->
            <div class="simulation_custom_content">
                <div class="simulation_content_head">
                    <h3>Curriculum</h3>
                </div>
                <div class="container">
                    <div  v-html="listing.curriculum" class="limit_text"></div>
                    <!-- <p>Not Applicable</p> -->
                </div>
            </div>

            <!-- Register Button -->
            <div class="d-flex ">
            <div v-if="success_register!=''" class="alert alert-success">
                <span>{{success_register}}</span>
            </div>
            </div>


            <div class="register_wrap d-flex justify-content-center mb-5">
                <a href="#" class="read_more disabled-course 00000" v-if="is_course_disable" >Register Now</a>
                <router-link class="read_more"  v-bind:to="'/login/?redirect_message=true&redirect=/courses/'+listing.slug" v-else-if="!auth">Register Now</router-link>

                <!-- <a href="#" class="read_more" :valy="not_login_yet" :click v-else-if="!auth">Register Now</a> -->
                <a href="#" class="read_more" :valy="already_registered" data-toggle="modal" data-target="#myModal" v-else-if="auth && user_already_registered==false">Register Now</a>
                <a href="#" v-else  class="read_more disabled-course">Register Now</a>
            </div>
        </div>
    </div>
</template>
<script>
import HeaderMenu from '../HeaderMenu'
import router from '../../router'
export default{
    data() {
        var current_user = this.$store.state.auth.current_user;
        return {
            errors:[],
            listing:null,
            hostname:this.$hostname,
            current_locale:this.$i18n_global.locale,
            cart_message:'',
            qty:1,
            course_error:'',
            name:(current_user!=null) ? current_user.name:'',
            scfhs_number:(current_user!=null) ? current_user.scfhs_number:'',
            profession:(current_user!=null) ? current_user.profession:'',
            workplace:(current_user!=null) ? current_user.workplace:'',
            contact_number:(current_user!=null) ? current_user.contact_number:'',
            email:(current_user!=null) ? current_user.email:'',
            success_register:'',
            register_btn_loader:false,
            auth: this.$store.state.auth.isLoggedIn,
            user: this.$store.state.auth.current_user,
            already_registered:false
        }
    },
    components:{
        HeaderMenu:HeaderMenu
    },
    mounted(){
        this.get_page_content();
    },
    computed: {
        user_already_registered () { 
            console.log("computed this.already_registered",this.already_registered);
            return this.already_registered; 
        }, 
        is_course_disable(){ 
            console.log("computed this.listing.disable_course",this.listing.disable_course);
            return this.listing.disable_course; 
        }
    },

    methods:{
        async check_course_booking(){
            var _self = this;
            if(_self.auth){
                await this.$axios_global.post(_self.$hostname+'/api/check-course-booking',{
                    course_id:_self.listing.id,
                    user_id:_self.user.id
                })
                .then((res) => {
                    var response = res.data.already_registered;
                    this.already_registered = response;
                    console.log(response,"response",res)
                    return true;
                })
                .catch((error) => {
                    console.log(error,"error")
                    return false;
                })
                return false;
            }
            else{
                return false;
            }
            
            
        },
        async get_page_content() {
            var _self = this;
            await this.$axios_global.post(_self.$hostname+'/api/course-details',{
              slug:_self.$route.params.slug
            })
            .then((res) => {
                var response = res.data.data;
                _self.$store.commit('set_user_token',res.data.token);
                _self.$store.commit('update_user',res.data.user);
                _self.listing = response;
                _self.check_course_booking();
                return true;
            })
            .catch((error) => {
                if(error.response.data.status=="empty"){
                    _self.course_error = "Course doesn't exists."
                }
                return false;
            })
            return false;
        },
        validateNumber: event => {
            let keyCode = event.keyCode;
            if (keyCode < 48 || keyCode > 57) {
                event.preventDefault();
            }
        },
        format_date(start,end){
            if (start && end) {
               var start_date_format =  this.$moment_global(String(start)).format('MMMM YYYY');
               var end_date_format   =  this.$moment_global(String(end)).format('MMMM YYYY');

               var start_year = this.$moment_global(String(start)).format('YYYY');
               var end_year = this.$moment_global(String(end)).format('YYYY');


                if(start_date_format == end_date_format){
                    var start_1 =  this.$moment_global(String(start)).format('Do');
                    var end_1   =  this.$moment_global(String(end)).format('Do MMMM YYYY');
                    return start_1 + ' - ' + end_1;
                }
                else if(start_year == end_year){
                    var start_1 =  this.$moment_global(String(start)).format('Do MMMM');
                    var end_1   =  this.$moment_global(String(end)).format('Do MMMM YYYY');
                    return start_1 + ' - ' + end_1;
                }
                else{
                    var start_1 =  this.$moment_global(String(start)).format('Do MMMM YYYY');
                    var end_1   =  this.$moment_global(String(end)).format('Do MMMM YYYY');
                    return start_1 + ' - ' + end_1;
                }
            }
            return '';
        },
        add_to_cart(){
            var course = this.$store.state.Cart.cart_items.find(row => row.id === this.listing.id);
            // this.$store.commit('add_to_cart',{id:this.listing.id,qty:1});
            $("#myModal .close").click();
            router.push({path: '/checkout/'+this.$route.params.slug+'/'})
        }
    }
}
</script>
<style scoped>
.course_detail_modal .modal_course_wrapper form .row{
    position:relative;
}
.course_detail_modal .modal_course_wrapper form .row .disabled-layer{
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 9999;
}
span.register_btn {
    cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/Courses/CourseDetails.vue